import { render } from "./view_event.html?vue&type=template&id=f0b4ddc2&external"
import script from "./view_event.js?vue&type=script&lang=js&external"
export * from "./view_event.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__